import React, { useContext, useEffect } from 'react'
import { Categories } from './categories'
import { Sessions } from './sessions'
import { ProjectContext } from '../../../context/ProjectContext'

export function Sidebar({ transcriptsView = false }) {
  const { groupNotesBy, sidebarScrollContainer } = useContext(ProjectContext)

  useEffect(() => {
    if (!sidebarScrollContainer) return

    sidebarScrollContainer.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [groupNotesBy, sidebarScrollContainer])

  if (transcriptsView) {
    // Hide the "General Notes" pseudo-session when we're on the Transcripts tab
    return <Sessions hideGeneralNotes />
  }

  // Hide sidebar in table view
  if (groupNotesBy === 'table') {
    return null
  }

  return groupNotesBy === 'meeting' ? <Sessions /> : <Categories />
}
